import { configureStore } from "@reduxjs/toolkit";
import categoryReducer from "../../features/category/categorySlice"
import productReducer from "../../features/product/productSlice"
import authReducer from "../../features/auth/authSlice";
import cartReducer from "../../features/cart/cartSlice"
import productDetailsReducer from "../../features/product/productDetails"
export const store = configureStore({
    reducer:{
          auth:     authReducer,
        categories: categoryReducer,
        products: productReducer,
        cart : cartReducer,
        productDetails: productDetailsReducer,
    },
})

    